const people = {
    FreidaRicher: {
        theme: 'one-photo',
        single: true,
        title: 'Always an enthusiastic, “Yes!”',
        body: [
            'A principal in our Edmonton Insolvency practice, Freida has more than a few roles – all of which help her have a lasting impact on her community. She’s our local practice leader and Trustee for our clients; she coaches and mentors our people; heads our community initiatives; and is our face and voice for consumer insolvency in local and national media. And it’s a good thing, too. Freida loves to talk about insolvency and financial issues that matter to Albertans. Whenever anyone asks her to give a presentation or seminar on financial literacy issues, do a TV or radio interview on insolvency topics, or speak to community groups about budgeting, Freida never hesitates. She always has an enthusiastic, “Yes!” It’s no wonder for the last five years she’s been a guest every month on the Global Edmonton morning news, talking about insolvency issues.',
            'Wearing different hats is easy for Freida because she loves what she does. She’s passionate about helping her community thrive and inspiring her team to provide positive client experiences. <strong>That&rsquo;s our purple. Discover yours.</strong>',
        ],
        author: {
            name: 'Freida Richer',
            job: 'Managing Partner, Consumer Insolvency'
        },
        images: [
            {
                media: 'Freida_Richer',
                type: 'image'
            }
        ],
    },
    SheilaKokotailo: {
        theme: 'staggered',
        title: 'New Firm, new friends',
        body: [
            `After working for a local firm in Penticton for 20 years Sheila was understandable nervous when she learned her company would be joining Doane Grant Thornton.  She soon learned that she’d been assigned a “Doane Grant Thornton Buddy” who immediately helped her feel connected to the Firm. Sheila had concerns about all the changes taking place around the transition and having a buddy there to support her made any stress she felt just melt away. She had a colleague who understood the systems and processes, procedures and culture. Someone she could bounce things off and trust. Someone who was always there for her – even though they were cities apart. Like when she called with questions about a new software, or when they virtually shared screens to walk through a program Sheila was having trouble with.`,
            `Getting that support after transitioning to different ways of doing things had a huge impact. Building that authentic connection and trust with a new colleague meant Sheila, literally, sighed with relief. She could continue to thrive and do great work – with people who might be new to her, but who were so amazing, they very quickly became like family. <strong>That’s our purple. Discover yours.</strong>`,
        ],
        author: {
            name: 'Sheila Kokotailo',
            job: 'Manager, Independent Business Group'
        },
        images: [
            {
                media: '1_Sheila_Kokotailo',
                type: 'image'
            },
            {
                media: '2_Sheila_Kokotailo',
                type: 'image'
            }
        ],
    },
    JoshWorsfold: {
        theme: 'video--single',
        title: 'Making dreams come true &ndash; a win-win-win',
        body: [
            'When Josh Worsfold first started working with a cherry and apple orchard business in BC’s Okanagan Valley, he was a staff accountant, helping with the company’s year-end bookkeeping. But through four years and the addition of numerous companies, he got involved with lots more, like hiring a Company Accountant, running five annual assurance reviews, and supporting an expansion bid into the US. At the same time, Josh put himself into the mix. He invited the owners and their sons to Kelowna Rockets hockey games and shared what was going on in his life, like the birth of his first child – and it’s had a huge impact. Now, not only do the owners rely on Josh for advice year-round on issues affecting the business – but their spouses ask about Josh’s wife and new baby, looking to see pictures and share stories. The owners’ sons ask him all kinds of business questions about new acquisitions, sure – but they also text him about what websites he recommends for good vacation deals.',
            'Being with the company from the get-go, understanding the ins and outs of the growing family business, and opening up about himself helped Josh gain confidence, learn lots about the orchard industry, and build trusted relationships with his clients. He’s having way more fun now, too – and it shows. <strong>That’s our purple. Discover yours.</strong>'
        ],
        author: {
            name: 'Josh Worsfold',
            job: 'Partner, Independent Business Group'
        },
        images: [
            {
                media: 'Josh_Worsfold',
                type: 'video'
            },
        ],
    },
    JimmyMartinez: {
        theme: 'two-photo',
        title: 'Giving back and pursuing what makes your happy',
        body: [
            `The small community feel is part of what Jimmy loves about living in Medicine Hat, Alberta. “Everyone helps you, no matter what you’re going through. Strangers will smile at you, buy you a coffee. The people are just outstanding,” he says. 
            Jimmy immigrated to the city from El Salvador with his family in 1995. Medicine Hat had a strong El Salvadorian community, with people going through the same struggles, and it’s this community that helped his family settle in the city. It’s also why he’s committed to staying and helping his community thrive, however he can.`,
            `Jimmy volunteers at local foodbanks and drives newly placed immigrants when they want to go grocery shopping or run errands. “They’ve been through a lot, and I want to help where I’m needed,” he says. Giving back to the community is a vital part of Jimmy’s life in Medicine Hat – one that fits in perfectly with Doane Grant Thornton’s focus on prioritizing overall wellbeing. `,
            `“In our office, you put your hours in, for sure, but your life is number one ahead of work,” he says. “The firm supports you in looking after yourself and pursuing what makes you happy. And for that I’m beyond grateful.” <strong>That’s our purple. Discover yours.</strong>`,
        ],
        author: {
            name: 'Jimmy Martinez',
            job: 'Senior Accountant, Assurance'
        },
        images: [
            {
                media: 'Jimmy_Martinez_1',
                type: 'image'
            },
            {
                media: 'Jimmy_Martinez_2',
                type: 'image'
            }
        ],
    },
    BaileyBodin: {
        theme: 'two-photo',
        title: 'The freedom to try new things',
        body: [
            `Bailey has learned a lot in her years with the firm’s Medicine Hat, Alberta, office—and much of that comes down to the freedom she has to try new things. Whenever Bailey wants to learn about or experiment with a new type of client or activity, she talks to her people manager about it and all kinds of doors start to open. `,
            `Like when she wanted to participate in the office’s recruiting efforts. Her people manager got the ball rolling and before she knew it, Bailey was connected to the right colleagues and able to help them hire amazing new professionals into Medicine Hat. `,
            `Or when she was trying to figure out if she wanted to do more Assurance work or focus her career on private business clients. Bailey got the chance to try out both paths before deciding to join our Independent Business Group (IBG). Now, Bailey gets to build strong relationships directly with owner-managed clients, have deeper conversations with them, answer their questions, and help solve their biggest challenges. And she just loves how happy her clients are—and how fulfilled she feels— when they get the support and insights they need to thrive. <strong>That’s our purple. Discover yours.</strong>`,
        ],
        author: {
            name: 'Bailey Bodin',
            job: 'Senior Accountant, Independent Business Group'
        },
        images: [
            {
                media: 'Bailey_Bodin_1',
                type: 'image'
            },
            {
                media: 'Bailey_Bodin_2',
                type: 'image'
            }
        ],
    },
}

const student = [
[

{
    slug: 'colleagues',
    ...people.SheilaKokotailo,
    nav: {
        next: 'communities'
    }
},

], [

{
    ...people.JimmyMartinez,
    slug: 'communities',
    nav: {
        prev: 'collegues',
        next: 'clients'
    }
},
{
    slug: 'communities',
    theme: 'one-photo',
    title: 'Even a little goes a long, long way',
    body: [
        'What does it feel like to be completely overwhelmed by sound? Or the dark? Or a splash of water? We don’t know, but Jessica Hudson does. Or, at least, she knows lots of kids who do. And she knows that even raising a little for Autism Ontario goes a long, long way. It helps a boy reach the end of his two-year journey to watch Spiderman on the big screen – thanks to a regular auditorium movie night, complete with low volume settings and night lights. It becomes a week at summer camp for teenagers who need round the clock care – thanks to an army of dedicated camp leaders. It’s swimming lessons for a girl so sensitive to water temperatures, she’s never been in a pool – thanks to small class sizes and a wetsuit.',
        'It means the time Jessica spends fundraising or balancing the books or mentoring new volunteers at Autism Ontario might be limited to just a few hours a week, but her impact is life changing. Just ask the boy who can watch a movie with his friends. Or the kids who can roast marshmallows around a campfire. Or the girl who can enjoy what it feels like to float. <strong>That&rsquo;s our purple. Discover yours.</strong>',
    ],
    author: {
        name: 'Jessica Hudson',
        job: 'Senior Analyst, Information Technology Services'
    },
    images: [
        {
            media: '1_Jessica_Hudson',
            type: 'image'
        }
    ],
    nav: {
        prev: 'collegues',
        next: 'clients'
    }
},

], [

{
    slug: 'clients',
    theme: 'staggered',
    title: 'Making dreams come true &ndash; a win-win-win',
    body: [
        'Soaking up the tropical sun at a hacienda in Mexico. Jetting off with your spouse to exotic locations all over the world. Playing hide-and-go-seek with the grandkids. Everyone’s idea of retirement is different, but for Patrick McCormack’s clients it was all these things. Who could blame them? They’d thought up a niche insurance product two decades ago and worked crazy hours for years building a strong, successful business that no one else had even dreamed of. They were amazing entrepreneurs, but into their sixties they wanted someone else to take over. And they couldn’t think of anyone they trusted more with the sale of their life’s work than their Doane Grant Thornton team.',
        'Being able to follow the client through the lifecycle of the business was a pivotal experience in Patrick’s career. Plus, as an Audit guy, he got to work on Tax implications and the complexities of a divestiture all in one go, which was pretty spectacular. And completing the sale with the right buyer, at the right price and without losing any employees had a massive impact on the two owners. It meant they could rest easy, get the kind of life they wanted and never have to worry about money again. A win-win-win, right? <strong>That’s our purple. Discover yours.</strong>'
    ],
    author: {
        name: 'Patrick McCormack',
        job: 'Partner, Assurance'
    },
    images: [
        {
            media: '1_Patrick_McCormick',
            type: 'image'
        },
        {
            media: '2_Patrick_McCormick',
            type: 'image'
        }
    ],
    nav: {
        prev: 'communities'
    }
},
{
    slug: 'clients',
    ...people.JoshWorsfold,
    nav: {
        prev: 'communities'
    }
},
{
    ...people.BaileyBodin,
    slug: 'clients',
    nav: {
        prev: 'communities',
    }
},

]]

const experienced = [
[

{
    slug: 'colleagues',
    ...people.SheilaKokotailo,
    nav: {
        next: 'communities'
    }
},
{

    slug: 'colleagues',
    theme: 'one-photo',
    title: 'No barriers to success',
    body: [
        `Getting talented people on board. Marketing yourself and the firm. Seizing the right opportunities when you spot them. Expanding your practice. It was so refreshing when I started my role as a partner in Doane Grant Thornton’s Tax group to see that there are no barriers to success. In fact, autonomy, entrepreneurship, building relationships, going out and getting new clients is encouraged and celebrated at the firm. If you see a chance to win a new client – you go for it.`,
        `It’s a sense of freedom to follow your own curiosity that makes the job easier and a lot more enjoyable. It’s challenging, don’t get me wrong, but it’s also less stressful not having to deal with the politics of an overly bureaucratic organization. Instead, you get collaboration and support from colleagues when creating new opportunities. Like when I saw the chance to collaborate with the Transactions Advisory Group to build more focus around M&A and tax. I had some conversations, jotted out a process, partnered with our transactions group, and that was it. New practice. Growing practice. Exciting practice.`,
        'At Doane Grant Thornton, you have more runway to find out what you want to do and then create those opportunities. People value you for who you are and what you can deliver. We take a long-term view and provide the space, support and encouragement so everyone thrives.  <strong>That’s our purple. Discover yours.</strong>',
    ],
    author: {
        name: 'Alex Smith',
        job: 'Partner'
    },
    images: [
        {
            media: '1_Alex_Smith',
            type: 'image'
        }
    ],
    nav: {
        next: 'communities'
    }
},

], [

{
    slug: 'communities',
    theme: 'two-photo',
    title: 'Giving back is part of our DNA',
    body: [
        '<em class=em>We’re only as strong as the communities that support us. Together, we continue to give back.</em',
        'As a Maritimer, Matt MacAdam feels part of a long history of coming together during times of need. It’s this spirit along with a desire to contribute to his community in a meaningful way that brought him to Halifax Search & Rescue. The organization is tasked with locating and rescuing missing persons as well as assisting civil emergencies such as evacuations for floods, and fires.',
        `The work can be both challenging and rewarding. “The recent forest fires in Halifax were a very stressful situation where we planned and executed a door-to-door evacuation of communities ahead of the fire path, giving people instructions for leaving and ensuring they had the assistance they needed where necessary. But one of my most gratifying memories was a search we did for an elderly dementia patient several years ago who had wandered away from home at night. After extensive searching from the air and ground, we found her lying in a bog in her nightgown and were able to bring her back to safety.”
        Matt feels his experiences at Doane Grant Thornton have prepared him for the challenges of search and rescue work. “What the firm has given me is self-confidence in my ability to be a leader. They’ve invested in me as a professional and as a person, and they’ve been incredibly supportive in allowing me to balance my work life with my family and volunteer time. The fact that helping our communities thrive is one of Doane Grant Thornton’s strategic priorities shows how much giving back is part of our DNA.”`,
        '<strong>That&rsquo;s our purple. Discover yours.</strong>',
    ],
    author: {
        name: 'Matthew MacAdam',
        job: 'Partner, Tax'
    },
    images: [
        {
            media: 'Matthew_MacAdam_2',
            type: 'image'
        },
        {
            media: 'Matthew_MacAdam_1',
            type: 'image'
        }
    ],
    nav: {
        prev: 'collegues',
        next: 'clients'
    }
},
{
    slug: 'communities',
    theme: 'one-photo',
    title: 'Even a little goes a long, long way',
    body: [
        'What does it feel like to be completely overwhelmed by sound? Or the dark? Or a splash of water? We don’t know, but Jessica Hudson does. Or, at least, she knows lots of kids who do. And she knows that even raising a little for Autism Ontario goes a long, long way. It helps a boy reach the end of his two-year journey to watch Spiderman on the big screen – thanks to a regular auditorium movie night, complete with low volume settings and night lights. It becomes a week at summer camp for teenagers who need round the clock care – thanks to an army of dedicated camp leaders. It’s swimming lessons for a girl so sensitive to water temperatures, she’s never been in a pool – thanks to small class sizes and a wetsuit.',
        'It means the time Jessica spends fundraising or balancing the books or mentoring new volunteers at Autism Ontario might be limited to just a few hours a week, but her impact is life changing. Just ask the boy who can watch a movie with his friends. Or the kids who can roast marshmallows around a campfire. Or the girl who can enjoy what it feels like to float. <strong>That&rsquo;s our purple. Discover yours.</strong>',
    ],
    author: {
        name: 'Jessica Hudson',
        job: 'Senior Analyst, Information Technology Services'
    },
    images: [
        {
            media: '1_Jessica_Hudson',
            type: 'image'
        }
    ],
    nav: {
        prev: 'collegues',
        next: 'clients'
    }
},
{
    ...people.JimmyMartinez,
    slug: 'communities',
    nav: {
        prev: 'collegues',
        next: 'clients'
    }
},
{
    ...people.FreidaRicher,
    slug: 'communities',
    nav: {
        prev: 'collegues',
        next: 'clients'
    }
}

], [

{
    slug: 'clients',
    theme: 'staggered',
    title: 'Making dreams come true &ndash; a win-win-win',
    body: [
        'Soaking up the tropical sun at a hacienda in Mexico. Jetting off with your spouse to exotic locations all over the world. Playing hide-and-go-seek with the grandkids. Everyone’s idea of retirement is different, but for Patrick McCormack’s clients it was all these things. Who could blame them? They’d thought up a niche insurance product two decades ago and worked crazy hours for years building a strong, successful business that no one else had even dreamed of. They were amazing entrepreneurs, but into their sixties they wanted someone else to take over. And they couldn’t think of anyone they trusted more with the sale of their life’s work than their Doane Grant Thornton team.',
        'Being able to follow the client through the lifecycle of the business was a pivotal experience in Patrick’s career. Plus, as an Audit guy, he got to work on Tax implications and the complexities of a divestiture all in one go, which was pretty spectacular. And completing the sale with the right buyer, at the right price and without losing any employees had a massive impact on the two owners. It meant they could rest easy, get the kind of life they wanted and never have to worry about money again. A win-win-win, right? <strong>That’s our purple. Discover yours.</strong>'
    ],
    author: {
        name: 'Patrick McCormack',
        job: 'Partner, Assurance'
    },
    images: [
        {
            media: '1_Patrick_McCormick',
            type: 'image'
        },
        {
            media: '2_Patrick_McCormick',
            type: 'image'
        }
    ],
    nav: {
        prev: 'communities'
    }
},
{
    ...people.BaileyBodin,
    slug: 'clients',
    nav: {
        prev: 'communities',
    }
},
{
    slug: 'clients',
    ...people.JoshWorsfold,
    nav: {
        prev: 'communities'
    }
},

]]

export default {
    student,
    experienced
}